'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NotificationHeaderArea = require('./NotificationHeaderArea');

var _NotificationHeaderArea2 = _interopRequireDefault(_NotificationHeaderArea);

var _NotificationContentArea = require('./NotificationContentArea');

var _NotificationContentArea2 = _interopRequireDefault(_NotificationContentArea);

var _NotificationActionArea = require('./NotificationActionArea');

var _NotificationActionArea2 = _interopRequireDefault(_NotificationActionArea);

var _close = require('material-ui/svg-icons/navigation/close');

var _close2 = _interopRequireDefault(_close);

var _reactTransitionGroup = require('react-transition-group');

var _materialUi = require('material-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The notificaiton implemenation for the web based on material design
 * defined at https://material.io/guidelines/patterns/notifications.html.
 * 
 * @author Timo Hanisch <timohanisch@googlemail.com>
 * @since 0.1.0
 */
var Notification = function (_React$Component) {
    _inherits(Notification, _React$Component);

    function Notification() {
        _classCallCheck(this, Notification);

        return _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).apply(this, arguments));
    }

    _createClass(Notification, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                actions = _props.actions,
                actionContent = _props.actionContent,
                avatar = _props.avatar,
                icon = _props.icon,
                headerLabel = _props.headerLabel,
                onClose = _props.onClose,
                primaryColor = _props.primaryColor,
                secondaryHeaderLabel = _props.secondaryHeaderLabel,
                timestamp = _props.timestamp,
                style = _props.style,
                title = _props.title,
                text = _props.text;

            return _react2.default.createElement(
                _materialUi.Paper,
                { style: _extends({}, Notification.STYLE.container, style) },
                _react2.default.createElement(_NotificationHeaderArea2.default, {
                    headerLabel: headerLabel,
                    icon: icon,
                    onClose: onClose,
                    primaryColor: primaryColor,
                    secondaryHeaderLabel: secondaryHeaderLabel,
                    timestamp: timestamp
                }),
                _react2.default.createElement(_NotificationContentArea2.default, {
                    avatar: avatar,
                    title: title,
                    text: text
                }),

                // Only render actions if the actions were passed to the component
                !!actions && _react2.default.createElement(_NotificationActionArea2.default, {
                    actions: actions,
                    primaryColor: primaryColor
                })
            );
        }
    }]);

    return Notification;
}(_react2.default.Component);

Notification.propTypes = {
    /* The title of the application/notification in the notification header */
    headerLabel: _propTypes2.default.string.isRequired,

    /* The callback function which is called when the user clicks on the closing button */
    onClose: _propTypes2.default.func.isRequired,

    /* Main title for the notification which is rendered into the content body of the notification */
    title: _propTypes2.default.string.isRequired,

    /* Text shown in the content body below the title */
    text: _propTypes2.default.string.isRequired,

    /* An avatar which should be added to the notification. May indiciate the creator of the notification to the user */
    avatar: _propTypes2.default.node,

    /* An array of action objects which are shown as flat buttons at the bottom of the notification */
    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        onClick: _propTypes2.default.func.isRequired
    })),

    /* An icon to be shown on the most left side of the notification header */
    icon: _propTypes2.default.node,

    /* By default notifications use the primary1color defined for the material-ui theme for the header and actions */
    primaryColor: _propTypes2.default.string,

    /* A string which is additionally drawn besides the headerLabel */
    secondaryHeaderLabel: _propTypes2.default.string,

    /* Indiciating the time when the notification was created */
    timestamp: _propTypes2.default.string,

    /* Inline styles which are applied to the notification container */
    style: _propTypes2.default.object
};
Notification.defaultProps = {
    avatar: null,
    actionArea: null,
    icon: null,
    secondaryHeader: '',
    timestamp: '',
    primaryColor: '',
    style: {}
};
Notification.STYLE = {
    container: {
        minWidth: 320,
        display: 'flex',
        flexDirection: 'column'
    }
};
exports.default = Notification;
module.exports = exports['default'];